export default __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-2-147eddc9f85c289f7c5ce57f1e89a4c0.png";